import * as React from 'react';
import { SVGProps } from 'react';

const IconPressureFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 18.488A9.004 9.004 0 0 0 21 10a9 9 0 1 0-18 0 9.004 9.004 0 0 0 6 8.488V20H7v2h10v-2h-2v-1.512Zm-2.357-6.593 1.428 1.59 1.414-1.414-1.585-1.445a2 2 0 0 0-2.697-2.46l-3.114-2.84-.707.706 2.804 3.125a2 2 0 0 0 2.457 2.738Z"
    />
  </svg>
);
export default IconPressureFilledSizeM;
